<template>
  <w-icon-wrapper 
    icon-name='work-work-icon'
    width="50" 
    height="50" 
    viewBox="0 0 50 50"
  >
    <g
      id="Gruppe_25280"
      data-name="Gruppe 25280"
      transform="translate(-314 -768)"
    >
      <path
        id="Pfad_55545"
        data-name="Pfad 55545"
        d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
        transform="translate(314 768)"
        fill="currentColor"
      />
      <g
        id="WORK_Logo"
        data-name="WORK Logo"
        transform="translate(327.328 782.743)"
      >
        <g
          id="Gruppe_3"
          data-name="Gruppe 3"
          transform="translate(0 0.027)"
        >
          <g
            id="Gruppe_1"
            data-name="Gruppe 1"
          >
            <path
              id="Pfad_1"
              data-name="Pfad 1"
              d="M4.126.1H0L5.873,20.561h3.81Z"
              transform="translate(0 -0.1)"
              fill="#fff"
            />
          </g>
          <g
            id="Gruppe_2"
            data-name="Gruppe 2"
            transform="translate(9.431)"
          >
            <path
              id="Pfad_2"
              data-name="Pfad 2"
              d="M54.61.1,50.589,14.246,48.9,7.573H44.8l3.579,12.988h4.1L58.714.1Z"
              transform="translate(-44.8 -0.1)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconWork' };
</script>
